import clsx from "clsx"
import { FC, useMemo } from "react"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useExpeditions } from "hooks/useExpeditions"
import { hapticFeedback } from "utils/hapticFeedback"
import { ExpeditionTimer } from "./ui/expedition-timer"
import { ExpeditionIcon } from "assets/icons"
import styles from "./index.module.scss"

interface ISideMenuExpeditions {}

export const SideMenuExpeditions: FC<ISideMenuExpeditions> = () => {
  const { i18n } = useTranslation()
  const { currExpedition, recoverAttempts } = useExpeditions()

  const nextRecovery = useMemo(() => {
    return currExpedition?.nextRecovery || []
  }, [currExpedition?.nextRecovery])

  return (
    <Link
      id="btn-adventures"
      to={"adventures/expeditions"}
      className={clsx(styles.SideMenuExpeditions, styles[i18n.language])}
      onClick={() => {
        hapticFeedback()
      }}
    >
      <img src={ExpeditionIcon} />
      {currExpedition?.attempts != 0 && (
        <div className={clsx(styles.SideMenuExpeditions_attempts)}>
          {currExpedition?.attempts}
        </div>
      )}
      {nextRecovery[0] && (
        <div className={clsx(styles.SideMenuExpeditions_timer)}>
          {nextRecovery.map((date: any) => (
            <ExpeditionTimer
              date={date}
              onExpire={recoverAttempts}
              key={date.toString()}
            />
          ))}
        </div>
      )}
    </Link>
  )
}
